// import "angular-material";
import * as angular from "angular";
import * as _ from "lodash";
import { DivisionDataProvider } from "../../data-provider/division.dp";
import { Division } from "../../models/division.model";
import { Organisation } from "../../models/organisation.model";
import { User } from "../../models/user.model";
import { PermissionCheck } from "../../shared/permission";
import { OrganisationInviteService } from "../../services/organisation-invite.service";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { LimitDataProvider } from "../../data-provider/limit.dp";
import { UserDataProvider } from "../../data-provider/user.dp";
import { Limit } from "../../models/limit.model";

let LeaderInviteComponent = {
    selector: "vcLeaderInvite",
    templateUrl:
        "/angular/components/organisation-invite/leader-invite.component.html",
    bindings: {
        organisation: "=?",
    },
    controller: class LeaderInviteController {
        // * bindings for typescript compiler *
        public organisation?: Organisation;
        // ************************************

        private $filter: any;
        private $mdConstant: any;
        private $timeout: any;
        private organisationInviteService: OrganisationInviteService;
        private divisionDataProvider: DivisionDataProvider;
        private limitDataProvider: LimitDataProvider;
        private userDataProvider: UserDataProvider;
        private toast: ToastUtils;
        private dialog: DialogUtils;

        public permissionProvider: PermissionCheck;
        public user: User;
        public emails: Array<any> = [];
        public invalidEmails: Array<any> = [];
        public searchString: string = "";
        public error: string = "";
        public errorMessage: string = "";
        public loading: boolean;
        public invite_loading: boolean;
        public limitExceededPage: boolean;
        public permissions: Array<any>;
        public separatorKeys: Array<any>;
        public divisions: Division[];
        public usersCount: object;
        public limits: Limit;

        constructor(
            $filter: any,
            $mdConstant: any,
            $timeout: any,
            OrganisationInviteService: OrganisationInviteService,
            PermissionCheck: PermissionCheck,
            DivisionDataProvider: DivisionDataProvider,
            UserDataProvider: UserDataProvider,
            LimitDataProvider: LimitDataProvider,
            ToastUtils: ToastUtils,
            DialogUtils: DialogUtils,
            ModelsUtils: any
        ) {
            this.$filter = $filter;
            this.$mdConstant = $mdConstant;
            this.organisationInviteService = OrganisationInviteService;
            this.permissionProvider = PermissionCheck;
            this.divisionDataProvider = DivisionDataProvider;
            this.$timeout = $timeout;
            this.toast = ToastUtils;
            this.dialog = DialogUtils;
            this.user = ModelsUtils.user({
                permission: {
                    permissionid: 9,
                    divisions: [],
                },
            });

            this.permissions = this.permissionProvider.levels;
            this.separatorKeys = [
                this.$mdConstant.KEY_CODE.COMMA,
                this.$mdConstant.KEY_CODE.SPACE,
                this.$mdConstant.KEY_CODE.ENTER,
                this.$mdConstant.KEY_CODE.SEMICOLON,
            ];

            this.userDataProvider = UserDataProvider;
            this.userDataProvider
                .getUsersCount()
                .then((count: object) => (this.usersCount = count));

            this.limitDataProvider = LimitDataProvider;
            this.limitDataProvider.get().then((limits: Limit) => {
                this.limits = limits;
                this.limitExceededPage = this.limitDataProvider.limitReached(
                    "super",
                    this.usersCount
                );
            });
            this.divisionDataProvider
                .getAllDivisions()
                .then((divisions: Division[]) => {
                    this.divisions = _.filter(
                        divisions,
                        (division: Division) => division.id != null
                    );
                    this.loading = false;
                });
        }

        sendInvite() {
            if (
                this.limitDataProvider.licensesUnavailable(
                    "super",
                    this.usersCount,
                    this.emails.length
                )
            ) {
                this.limitExceededPage = true;
                return;
            }
            this.invite_loading = true;
            let data: any = this.organisation
                ? _.cloneDeep(this.organisation)
                : {};
            data.permissionid = this.user.permission.permissionid;
            data.divisionids =
                data.permissionid == 10 && this.user.permission.divisions
                    ? this.user.permission.divisions
                    : null;

            data.emails = this.emails;
            this.organisationInviteService.create(data).then((response) => {
                let json = response["data"];
                this.invite_loading = false;
                if (json.success) {
                    this.toast.success("Invites sending...");
                    this.userDataProvider.resetUsersCount();
                    this.dialog.hide(this.user);
                } else {
                    this.errorMessage = json.data.message;
                }
            });
        }

        validateEmail(x: any) {
            if (!this.$filter("isValidEmail")(x)) {
                this.emails.pop();
                this.invalidEmailError();
            }
        }

        updatePermission() {
            angular.forEach(this.permissions, (permission) => {
                if (
                    permission.permissionid == this.user.permission.permissionid
                ) {
                    this.user.permission.permissionname =
                        permission.internalName;
                }
            });
        }

        invalidEmailError() {
            this.error = "Invalid email address";
            this.$timeout(() => {
                this.error = "";
            }, 3000); //wait 3 Seconds and hide
        }

        paste(event: any) {
            event.preventDefault();
            this.invalidEmails = [];
            let emailList = event.clipboardData.getData("Text").split(/;|,|\n/);
            angular.forEach(emailList, (value) => {
                let email = value.trim();
                if (email && this.$filter("isValidEmail")(email)) {
                    if (
                        this.emails.length < 1000 &&
                        this.emails.indexOf(value.trim()) == -1
                    ) {
                        this.emails.push(email); //Push if valid
                    }

                    if (this.emails.length >= 1000) {
                        this.error =
                            "You have reached the max limit of 1,000 email addresses.";
                    }
                } else if (
                    !this.$filter("isValidEmail")(email) &&
                    email.trim() != ""
                ) {
                    this.invalidEmails.push(email);
                }
            });

            if (this.invalidEmails.length > 1) {
                this.error =
                    "Some of your emails were invalid: " +
                    this.invalidEmails.join(", ");
            }
        }

        clickDivision(division: Division): void {
            if (this.isDivisionChecked(division)) {
                const $index = this.user.permission.divisions.indexOf(
                    division.id
                );
                this.user.permission.divisions.splice($index, 1);
            } else {
                this.user.permission.divisions.push(division.id);
            }
        }

        isDivisionChecked(division: Division): boolean {
            return (
                !!this.user.permission.divisions &&
                this.user.permission.divisions.includes(division.id)
            );
        }

        addEmail(email: string): void {
            this.emails.push(email);
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("organisationInvite", [
        "nvd3",
        "ngMaterial",
        "ngMaterialDateRangePicker",
        "LocalStorageModule",
    ])
    .component(LeaderInviteComponent.selector, LeaderInviteComponent);
